import { render, staticRenderFns } from "./LeagueClubs.vue?vue&type=template&id=442f1e1f"
import script from "./LeagueClubs.vue?vue&type=script&lang=js"
export * from "./LeagueClubs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports